import Helper from '@ember/component/helper';
import { isBlank } from '@ember/utils';

export const LANGUAGE_CODE_ALIASES = Object.freeze({
  'zh-hans': Object.freeze(['zh-cn']),
  'zh-hant': Object.freeze(['zh-tw']),
});

export default class Translator extends Helper {
  compute([translations], { languageCode, defaultText }) {
    if (isBlank(translations)) {
      return defaultText;
    }

    const translated = translations.find(({ languageCode: code }) => {
      const aliases = LANGUAGE_CODE_ALIASES[languageCode.toLowerCase()] || [];
      const codes = [languageCode, ...aliases];
      const lowerCode = code.toLowerCase();

      return codes.some((c) => c.toLowerCase() === lowerCode);
    });

    if (translated) {
      return translated.displayName;
    }

    return defaultText;
  }
}
